import * as React from "react"
import { forwardRef } from "react"
import { Checkbox as ShadcnCheckbox } from "@/components/ui/checkbox"
import { clsx } from "clsx"

export interface CheckboxProps
  extends Omit<React.ComponentPropsWithoutRef<typeof ShadcnCheckbox>, "size"> {
  label?: string
  description?: string
  size?: "sm" | "md" | "lg"
}

export const Checkbox = forwardRef<
  React.ElementRef<typeof ShadcnCheckbox>,
  CheckboxProps
>(({ label, description, size = "md", className, disabled, ...props }, ref) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  }

  const labelSizeClasses = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base",
  }

  return (
    <label
      className={clsx(
        "flex items-center gap-3 cursor-pointer",
        disabled && "cursor-not-allowed opacity-50"
      )}
    >
      <ShadcnCheckbox
        ref={ref}
        disabled={disabled}
        className={clsx(
          sizeClasses[size],
          "mt-0.5",
          className
        )}
        {...props}
      />

      {(label || description) && (
        <div className="flex flex-col">
          {label && (
            <span
              className={clsx(
                "text-foreground leading-none",
                labelSizeClasses[size]
              )}
            >
              {label}
            </span>
          )}
          {description && (
            <span className="text-xs text-muted-foreground mt-1">
              {description}
            </span>
          )}
        </div>
      )}
    </label>
  )
})

Checkbox.displayName = "Checkbox"
